import React from 'react';
import ReactDOM from 'react-dom';
import FormModuleLookup from '../components/FormModuleLookup';
import EditorForDataGridMix from './EditorForDataGridMix';
import LookupActions from '../actions/LookupActions';
import RecordsActions from '../actions/RecordsActions';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import Warning from '../utils/Warn';
import FormItemDateEditor from './FormItemDateEditor';
import FormItemDateResolver from './resolver/FormItemDateResolver';
import FormItemConst from './FormItemConst';
import {DsAllowEditStore} from '../stores/CmdTypeStore';

export default class FormItemDateEditorForDataGrid extends EditorForDataGridMix(FormItemDateEditor)
{

	initStores()
	{
		this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeDsAllowEditStore();
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	getValue(){
		console.log(this.props.column.key);
	    let updated = {};
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		this.justCommit = true;
	    let text = this.getInputNode().value;
		var _val = FormItemDateResolver.getResult(text,false);
		
		if(_val.indexOf("false:") == 0)
		{
			Warning.show({text:_val.substr(6)});
			_val = this.props.value;
		}

	    updated[this.props.column.key] = _val;

	    if(this.props.value != updated[this.props.column.key])
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,this.props.value,null,null,{dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,this.props.value);
				}
				 
	    		if(!result && !this.props.control.isDataMethodField)
	    		{
	    			return {};
	    		}
				if(this.props.rowData[this.props.column.key] != this.props.value && this.props.rowData[this.props.column.key]!=_val){
					_val = this.props.rowData[this.props.column.key];
					updated[this.props.column.key] = _val;
				}
	    	}
	    }
	    return updated;
	}

	//当有下拉框存在的时候 项目编辑器在失去焦点时不销毁
	//下拉框是否销毁由项目编辑器决定
	handleBlurCommit()
	{
		if(this.justCommit == true)
		{
			this.justCommit = false;return false;
		}
	   if(this.lookupStates.isShowed)
	   	return false;
	   return true;
	}

	componentDidMount()
	{

		let _displayStyle = this.props.control.getProperty_DisplayStyle();
		let dataFormat ;
		if(_displayStyle && _displayStyle.DisplayFormat)
		{
			dataFormat = _displayStyle.DisplayFormat;
		}
		else
		{
			dataFormat = _displayStyle.DisplayFormat;
		}
		let startView=0;
		let minViewMode=0;
		let format = "yyyy-mm-dd";
		if(!dataFormat || dataFormat == "yyyy-MM-dd" || dataFormat == "MM-dd"){
			 startView=0;
			 minViewMode=0;
		}else if(dataFormat == "yyyy-MM"){
			startView=1;
			minViewMode=1;
		}else if(dataFormat == "yyyy"){
			startView=2;
			minViewMode=2;
		}
		$(this.inputField).datepicker({
		      language: 'zh-CN',
		      autoclose: true,//选中之后自动隐藏日期选择框
		      clearBtn: true,//清除按钮
		      todayBtn: true,//今日按钮
		      format: "yyyy-mm-dd",
		      buttonImageOnly: true,
		      todayHighlight:true,
			  startView:startView,
			  minViewMode:minViewMode,
		      hide:this.onDatePanelClose.bind(this)
		});
		
		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
			this.doSetEnable(_allowEdit);
		}
		let copy = Object.assign({},this.props.contextMenuData);
		if(copy.items)
		{
			for(let i = 0;i<copy.items.length;i++)
			{
				let item = copy.items[i];
				if(item && item.label == "过滤[Ctrl+T]")
				{
					item.action = this.queryFilter.bind(this);
					break;
				}
			}
			$(this.inputField).contextPopup(copy);
		}
		else
		{
			$(this.inputField).contextPopup(this.props.contextMenuData);
		}
	}

	queryFilter()
	{
		if(!this.props.control || !this.props.control.group)
			return;
		var _dataField = this.props.dataField;
		if(_dataField && this.props.rowData && this.props.rowData.hasOwnProperty(_dataField))
		{
			
			var value = this.props.rowData[_dataField];
			this.props.control.group.queryFilter(_dataField,value);
		}
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.inputField).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			$(this.inputField).attr("readonly","readonly");
			$(this.downArrowButton).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			
		}
		else if(nowAllowEdit == false && enable == true)
		{
			$(this.inputField).css("backgroundColor","#FFFFFF");
			$(this.inputField).removeAttr("readonly");
			$(this.downArrowButton).css("backgroundColor","#FFFFFF");
			
		}
	}

	onKeyDownHandler2(e)
	{
		if(e.ctrlKey && e.keyCode == 65)
		{
		e.stopPropagation();
		return true;
		}
	}
	
	render()
	{
		let rowStyles = this.getRowStyles();
		let _style = {padding:'2px',backgroundColor:'#ffffff',fontSize:"12px",cursor:'text',paddingRight:'13px'};
		let _textAlign = this.props.control.getProperty_Alignment();
		_style.textAlign = _textAlign.toLowerCase();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		if(this.props.height){
			_style.maxHeight=this.props.height-2;
		}
		let _v = this.props.value;
		/*if(this.props.hasInitialValue == true && this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final();

			if(_allowEdit == false)
			{
				if(this.props.column && this.props.column.key)
				{
					let _value = this.props.rowData[this.props.column.key];
					_v = _value;
				}
			}
		}*/
		//<div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',paddingLeft:'2px',paddingRight:'2px',paddingBottom:'1px'}} onClick={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>
		return(
		    <div className="input-group date" style={{width:'100%'}}>
		        <input spellCheck="false" id={"input"+this.props.xml.id} type="text" className="form-control pull-right" defaultValue={_v} ref={ node => this.inputField = node } style={_style} onKeyDown={this.onKeyDownHandler2.bind(this)}/>
		        <i ref={node => this.downArrowButton = node} className="fa fa-calendar" onClick={this.showDateDropDown.bind(this)} style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
		    </div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/formItem/FormItemDateEditorForDataGrid.js